import React, {type ReactNode, useEffect} from 'react';

import {Analytics} from '../../services/analytics';
import {type EventData} from '../../services/analytics/types';
type Props = {
  button?: ReactNode;
  children?: ReactNode;
  className?: string;
  eventData?: EventData;
  style?: React.CSSProperties;
};

export const AccountStatusBanner = React.memo(
  ({eventData, ...props}: Props) => {
    useEffect(() => {
      if (eventData) {
        Analytics.track('Account Status Banner Viewed', eventData ?? {});
      }
    }, []); // oxlint-disable-line react-hooks/exhaustive-deps

    return (
      <div
        {...props}
        className="
          font-source-sans-pro min-h-60 flex items-center
          justify-between gap-8 bg-[light-dark(var(--gold-400),var(--gold-800))]
          p-16 text-left text-base font-normal tracking-normal
          text-[light-dark(var(--moon-800),var(--moon-100))]"
      />
    );
  }
);
AccountStatusBanner.displayName = 'AccountStatusBanner';

export const AccountStatusBannerFlexWrapper = React.memo(
  ({children}: {children?: ReactNode}) => {
    return <div className="flex w-full items-center gap-8">{children}</div>;
  }
);
AccountStatusBannerFlexWrapper.displayName = 'AccountStatusBannerFlexWrapper';

export const AccountStatusBannerTextWrapper = React.memo(
  ({children}: {children?: ReactNode}) => {
    return <div className="flex gap-4">{children}</div>;
  }
);
AccountStatusBannerTextWrapper.displayName = 'AccountStatusBannerTextWrapper';

export const AccountStatusBannerBoldText = React.memo(
  ({children}: {children?: ReactNode}) => {
    return <span className="font-semibold">{children}</span>;
  }
);
AccountStatusBannerBoldText.displayName = 'AccountStatusBannerBoldText';
